import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import { PaginationRequest } from "../types"
import {
	DeclarationsSearchParams,
	HistoryCardResponseData,
	DeclarationResponse,
	GetProjectDetailResponse,
	ProjectReferenceData,
} from "./types"

export const getProjects = (
	apiClient: APIClient,
	pagination: PaginationRequest,
): Promise<ProjectReferenceData> =>
	apiClient
		.get("/declarations/project-references", {
			params: pagination,
		})
		.then(response => response.data)

export const getProjectById = (
	apiClient: APIClient,
	id: string,
): Promise<GetProjectDetailResponse> =>
	apiClient
		.get(`/declarations/project-references/${id}`)
		.then(response => response.data)

export const getDeclarationsForProject = (
	apiClient: APIClient,
	searchParams: DeclarationsSearchParams,
): Promise<DeclarationResponse[]> =>
	apiClient
		.get("/declarations", {
			params: searchParams,
		})
		.then(response => response.data)

export const getProjectHistoryCardData = (
	apiClient: APIClient,
	projectReferenceId: string,
): Promise<HistoryCardResponseData> =>
	apiClient
		.get("/declarations/history-cards", {
			params: { projectReferenceId },
		})
		.then(response => response.data)
